module.exports = "/_next/static/images/icon_phone-192d6a604b8b8b82810ed2cb0fa18c3d.svg";